// 引入所有API
import headerApi from './headerApi';
import newBfdHeaderApi from './newBfdHeaderApi';
export default {
  headerApi,
  newBfdHeaderApi,
};
